import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { CaseModel } from '../models/case.model';
import { DocumentModel } from '../models/document.model';
import { ApiService } from './api.service';
import { ObjectModel } from '../models/object.model';
import { PortalSendModel } from '../models/portal-send.model';

@Injectable()
export class PortalService {
  constructor(private apiService: ApiService) {}

  sendDocument(model: PortalSendModel): Observable<any> {
    // we don't want to send the answers and objects back to the server
    model.answers = [];
    model.objects = new Map<string, ObjectModel[]>();
    return this.apiService.post('portal/SendDocument', model, {
      showToast: false,
    });
  }

  getServices(model: DocumentModel): Observable<any> {
    // we don't want to send the answers and objects back to the server
    model.answers = [];
    model.objects = new Map<string, ObjectModel[]>();
    return this.apiService.post('portal/GetServices', model, {
      showToast: false,
    });
  }
}
